module.exports = __webpack_public_path__ + "b0f9550c3daad00678f6dc8238f97bfc.png";